const stickyInit = () => {
  const addToCartButton: HTMLElement = document.querySelector('.real-cart-button');
  const addToCartButtonFloat: HTMLElement = document.querySelector('.floating-cart-button');

  const options: any = {
    rootMargin: '-121px 0px 100%',
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        addToCartButtonFloat.classList.remove('remove-button');
        addToCartButtonFloat.classList.add('float-button');
      } else {
        addToCartButtonFloat.classList.remove('float-button');
        addToCartButtonFloat.classList.add('remove-button');
      }
    });
  }, options);

  setTimeout(() => {
    if (addToCartButton) {
      observer.observe(addToCartButton);
    }
  }, 2000);
};

export default stickyInit;
